<div class="NotificationMessage">
    <div [ngClass]="applyClass()">
        <div class="bx">
            <i class="fa-solid " [ngClass]="applyicon()"></i>
            <span>{{ notificationMessage.get(type)! | translate }}</span>
        </div>
        <div id="btnCloseNotify" (click)="closeNotification()"><i class="fa-solid fa-circle-xmark"></i></div>
    </div>
</div>
